///<reference path="../../_ext/editors/EditorDialogBase.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKURepricingDetailsDialog extends _Ext.ItemEditorDialog<SKURepricingDetailsRow> {
        protected getFormKey() { return SKURepricingDetailsForm.formKey; }
        protected getLocalTextPrefix() { return SKURepricingDetailsRow.localTextPrefix; }
        protected getDeletePermission() { return SKURepricingDetailsRow.deletePermission; }
        protected getInsertPermission() { return SKURepricingDetailsRow.insertPermission; }
        protected getUpdatePermission() { return SKURepricingDetailsRow.updatePermission; }
        protected get_ExtDialogOptions(): ExtDialogOptions { return Q.deepClone(q.DefaultEntityDialogOptions); }

        public Closing: boolean;

        protected form = new SKURepricingDetailsForm(this.idPrefix);
        constructor() {
            super();

    
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            //q.setTextRightAlign(this.form.NewSKU);
          /*  this.form.NewSKU.changeSelect2(e => {
                if (this.form.ItemsDetails.getItems().length > 0) {
                    var Items = [];
                    var pcs = this.form.Pieces.value - this.form.ItemsDetails.getItems().length;
                    if (pcs >= this.form.NewSKU.value) {
                        var returnitem = this.form.ItemsDetails.setData(this.entity, this.entity.AttributeId, this.form.NewSKU.value);
                       // (this.parentEditor.parentDialog as SKUCostingDialog).setPrintingGrid(returnitem);
                    }
                    //this.form.ItemsDetails.setItems(Items);
                    if (pcs <= this.form.NewSKU.value)
                        this.form.ItemsDetails.setData(this.entity, this.entity.AttributeId, pcs);                    
                    else
                        Q.notifyError('Invalid Value(New SKU) should be less than Pieces');

                } else {
                    if (this.form.NewSKU.value <= this.form.Pieces.value) {
                        var returnitem =  this.form.ItemsDetails.setData(this.entity, this.entity.AttributeId, this.form.NewSKU.value);
                        //(this.parentEditor.parentDialog as SKUCostingDialog).setPrintingGrid(returnitem);
                    }
                    else
                        Q.notifyError('Invalid Value(New SKU) should be less than Pieces');
                }
                this.form.NewSKU.element.focus;
            });*/
        }
   
    }
}